import naja from "naja";
import * as L from 'leaflet';
class S84Maps {
    constructor() {

    }

    initialize(naja) {
        naja.addEventListener('init', () => {
            let myMap = document.getElementById('contact-map');
            let markerDialogDisabled = myMap.dataset.markerDialog === 'off';

            var m = L.map(myMap).setView([49.1131, 16.1830], 17);
            L.tileLayer('https://tile.openstreetmap.org/{z}/{x}/{y}.png', {
                maxZoom: 19,
                attribution: '&copy; <a href="http://www.openstreetmap.org/copyright">OpenStreetMap</a>'
            }).addTo(m);

            let markerImg = '/public-data/gps-mark-full.png';

            const icon = L.icon({
                iconUrl: markerImg,
                iconSize: [250, 239],
                iconAnchor: [110, 180],
            });

            var marker = L.marker([49.1131, 16.1830], {
                icon: icon,
                title: 'LIMID Mohelno, s.r.o.',
            }).addTo(m);

        })
    }
}

naja.registerExtension(new S84Maps());